/** Motivos de não liberações de pedidos */
export enum PedidoMotivoNaoLiberado {
    SEM_MOTIVO = 0,
    BONIFICACAO_EXCEDENTE = 1,
    // RESULTADO_LIQUIDO_ABAIXO = 2,
    LUCRO_LIQUIDO_ABAIXO = 3,
    PERC_DESCONTOS_MAXIMOS_ITENS_EXCEDIDOS = 4,
    CLIENTE_INADIMPLENTE = 5,
    LIMITE_CREDITO_EXCEDIDO = 6
}

/** Valor de uma não liberação de pedidos */
export interface PedidoMotivoNaoLiberadoValue {
    id: PedidoMotivoNaoLiberado;
    nome: string;
    abreviacao: string;
}

/** Motivo de bonificação excedente */
export const PEDIDO_MOTIVO_NAO_LIBERADO_BONIFICACAO_EXCEDENTE: PedidoMotivoNaoLiberadoValue = {
    id: PedidoMotivoNaoLiberado.BONIFICACAO_EXCEDENTE,
    nome: 'Percentual da bonificação excedeu o máximo permitido para a campanha selecionada no pedido',
    abreviacao: 'Bonificação Excedente'
};

// export const PEDIDO_MOTIVO_NAO_LIBERADO_RESULTADO_LIQUIDO_ABAIXO: PedidoMotivoNaoLiberadoValue = {
//     id: PedidoMotivoNaoLiberado.RESULTADO_LIQUIDO_ABAIXO,
//     nome: 'Percentual do resultado líquido do pedido abaixo do mínimo permitido',
//     abreviacao: 'Resultado Líquido Abaixo'
// };

/** Motivo de lucro líquido abaixo */
export const PEDIDO_NAO_LIBERADO_LUCRO_LIQUIDO_ABAIXO: PedidoMotivoNaoLiberadoValue = {
    id: PedidoMotivoNaoLiberado.LUCRO_LIQUIDO_ABAIXO,
    nome: 'Percentual do lucro líquido do pedido abaixo do mínimo permitido',
    abreviacao: 'Lucro Líquido Abaixo'
};

/** Motivo de descontos dos itens acima do limite permitido */
export const PEDIDO_NAO_LIBERADO_PERC_DESCONTOS_MAXIMOS_ITENS_EXCEDIDOS: PedidoMotivoNaoLiberadoValue = {
    id: PedidoMotivoNaoLiberado.PERC_DESCONTOS_MAXIMOS_ITENS_EXCEDIDOS,
    nome: 'Descontos dos itens acima do limite permitido',
    abreviacao: 'Descontos dos itens excedidos'
};

/** Motivo de cliente inadimplente */
export const PEDIDO_NAO_LIBERADO_CLIENTE_INADIMPLENTE: PedidoMotivoNaoLiberadoValue = {
    id: PedidoMotivoNaoLiberado.CLIENTE_INADIMPLENTE,
    nome: 'Cliente inadimplente',
    abreviacao: 'Cliente Inadimplente'
};

/** Motivo de limite de crédito excedido */
export const PEDIDO_NAO_LIBERADO_LIMITE_CREDITO_EXCEDIDO: PedidoMotivoNaoLiberadoValue = {
    id: PedidoMotivoNaoLiberado.LIMITE_CREDITO_EXCEDIDO,
    nome: 'Limite de crédito excedido',
    abreviacao: 'Limite de Crédito Excedido'
};

/** Motivos das não liberações dos pedidos */
export const PEDIDOS_MOTIVOS_NAO_LIBERADOS: PedidoMotivoNaoLiberadoValue[] = [
    PEDIDO_MOTIVO_NAO_LIBERADO_BONIFICACAO_EXCEDENTE,
    PEDIDO_NAO_LIBERADO_LUCRO_LIQUIDO_ABAIXO,
    PEDIDO_NAO_LIBERADO_PERC_DESCONTOS_MAXIMOS_ITENS_EXCEDIDOS,
    PEDIDO_NAO_LIBERADO_CLIENTE_INADIMPLENTE,
    PEDIDO_NAO_LIBERADO_LIMITE_CREDITO_EXCEDIDO
];

/** Verifica se o motivo da não liberação é pela bonificação excedente */
export function isPedidoMotivoNaoLiberadoBonificacaoExcedente(motivo?: number): boolean {
    return motivo !== undefined && motivo === PEDIDO_MOTIVO_NAO_LIBERADO_BONIFICACAO_EXCEDENTE.id;
}

/** Verifica se o motivo da não liberação é pelo lucro líquido abaixo do mínimo permitido */
export function isPedidoMotivoNaoLiberadoLucroLiquidoAbaixo(motivo?: number): boolean {
    return motivo !== undefined && motivo === PEDIDO_NAO_LIBERADO_LUCRO_LIQUIDO_ABAIXO.id;
}

/** Verifica se o motivo da não liberação é pelo desconto do item estar acima do limite permitido */
export function isPedidoMotivoNaoLiberadoPercDescontosMaximosItensExcedidos(motivo?: number): boolean {
    return motivo !== undefined && motivo === PEDIDO_NAO_LIBERADO_PERC_DESCONTOS_MAXIMOS_ITENS_EXCEDIDOS.id;
}

/** Verifica se o motivo da não liberação é pelo cliente inadimplente */
export function isPedidoMotivoNaoLiberadoClienteInadimplente(motivo?: number): boolean {
    return motivo !== undefined && motivo === PEDIDO_NAO_LIBERADO_CLIENTE_INADIMPLENTE.id;
}

/** Verifica se o motivo da não liberação é pelo limite de crédito excedido */
export function isPedidoMotivoNaoLiberadoLimiteCreditoExcedido(motivo?: number): boolean {
    return motivo !== undefined && motivo === PEDIDO_NAO_LIBERADO_LIMITE_CREDITO_EXCEDIDO.id;
}

/** Verifica se o motivo da não liberação é válido */
export function isPedidoMotivoNaoLiberadoValid(motivo?: number): boolean {
    return motivo !== undefined && PEDIDOS_MOTIVOS_NAO_LIBERADOS.some(m => m.id === motivo);
}
